<template>
  <div class="bluefire-wap-wrap">
    <wap-header header-text="用户编辑" :header-visible="true" :back-visible="true" /><!--参数都可以不传-->
    <div class="user-edit-wrap" id="anchor1">
      <div class="form-area">
        <el-form :model="editData" ref="formData" class="form" :disabled="!isFibSite">
          <div class="title-area">基础信息</div>
          <el-form-item label="姓名" label-width="15%" >
            <el-input placeholder="请输入" v-model="editData.custom_name"></el-input>
          </el-form-item>
          <el-form-item label="电话" label-width="15%" >
            <el-input placeholder="请输入" v-model="editData.crm_tel"></el-input>
          </el-form-item>
          <el-form-item label="微信" label-width="15%" >
            <el-input placeholder="请输入" v-model="editData.crm_weixin"></el-input>
          </el-form-item>
          <el-form-item label="QQ" label-width="15%" >
            <el-input placeholder="请输入" v-model="editData.crm_qq"></el-input>
          </el-form-item>
          <div class="form-hr"><i></i></div>
          <el-form-item label="客户分级" label-width="22%">
            <jm-dict-select
              type="dataset"
              @change="bindUserStatus"
              v-model="editData.crm_level_lv"
              dict-type="student"
              :filter="crmLevelFilter"
              name="customLvType"/>
          </el-form-item>
          <el-form-item label="入学时间" label-width="22%">
            <div class="morewrap">
              <el-date-picker
                v-model="editData.custom_year"
                type="year"
                format="yyyy"
                value-format="yyyy"
                placeholder="请选择"
                ref="customer_year"
                class="moremode"
                :editable="false"
              />
              <el-date-picker
                :disabled="!editData.custom_year"
                v-model="editData.custom_month"
                format="MM"
                value-format="MM"
                type="month"
                placeholder="请选择"
                popper-class="process-list-popper"
                class="moremode"
                :editable="false"
              />
            </div>
          </el-form-item>
          <div class="form-hr" id="anchor2"><i></i><span>备注内容</span></div>
          <el-form-item>
            <el-input v-model="editData.crm_memo" type="textarea" placeholder="请输入" resize="none" :autosize="{ minRows: 6 }"></el-input>
          </el-form-item>
          <div class="form-hr" id="anchor3"><i></i><span>个人信息</span></div>
          <el-form-item label="昵称" label-width="22%">
            <el-input placeholder="请输入" v-model="editData.custom_nickname_tell"></el-input>
          </el-form-item>
          <!-- <el-form-item label="创建人" label-width="22%">
            <span class="text-area">{{ editData.create_person_value }}{{ `（${editData.create_time}）` }}</span>
          </el-form-item> -->
          <el-form-item label="采集功能" label-width="22%">
            <span class="text-area">{{ editData.create_point_value }}{{ `（${editData.create_time}）` }}</span>
          </el-form-item>
          <el-form-item label="推广人" label-width="22%">
            <span class="text-area">{{ editData.custom_promoter_value }}</span>
          </el-form-item>
          <el-form-item v-if="this.countrys" label="意向国家" label-width="22%">
            <el-select
              v-model="editData.custom_hope_country"
              multiple
              placeholder="请选择">
              <el-option
                v-for="item in this.countrys"
                :label="item.value"
                :value="item.id"
                :key="item.id"
                v-if="!canEditSayer || [1808, 1868, 2044, 1880].indexOf(item.id) === -1"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="说明" label-width="22%" v-if="this.editData.custom_hope_country.indexOf(2061)!==-1">
            <el-select
              clearable
              v-model="editData.singapore_explain"
              placeholder="意向国家是新加坡时必填">
              <el-option
                v-for="item in singapore_explain"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <div class="form-hr" id="anchor4"><i></i><span>其他信息</span></div>
          <el-form-item label="活动编码" label-width="22%">
            <el-input placeholder="请输入" v-model="editData.activity_code" :disabled="!canEditByCreator"></el-input>
          </el-form-item>
          <el-form-item label="资源互转" label-width="22%">
            <el-select
              clearable
              v-model="editData.crm_zhuanxiang"
              placeholder="请选择">
              <el-option
                label="芥末转前程"
                :value="1">芥末转前程</el-option>
              <el-option
                label="前程转芥末"
                :value="2">前程转芥末</el-option>
              <el-option
                label="call center激活"
                :value="3">call center激活</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务切片" label-width="22%">
            <el-select
              clearable
              v-model="editData.country_business"
              placeholder="请选择">
              <el-option
                v-for="item in services"
                :key="item.id"
                :label="`[${item.country}]${item.value}`"
                :value="item.id"/>
            </el-select>
          </el-form-item>
          <el-form-item v-if="isJiemoJpStudent" label="芥末日本VIP" label-width="22%" class="moreline">
            <el-select v-model="editData.jiemo_vip" placeholder="请选择" :disabled="!canEditSayer">
              <el-option label="否" :value="0"></el-option>
              <el-option label="是" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="isJiemoJpStudent" label="短期留学" label-width="22%">
            <el-select v-model="editData.short_study_abroad" placeholder="请选择">
              <el-option label="否" :value="0"></el-option>
              <el-option label="是" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="签约类型" label-width="22%" v-if="hasSignType">
            <el-radio-group v-model="signType1">
              <el-radio :label="1" v-if="hasStandard">Standard</el-radio>
              <el-radio :label="2" v-if="hasPlus">Plus</el-radio>
              <el-radio :label="3" v-if="canFree">Free</el-radio>
            </el-radio-group>
            <el-checkbox-group v-model="signType2">
              <el-checkbox :label="4">短期</el-checkbox>
              <el-checkbox :label="5">语培</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <div class="title-area" id="anchor5">签约信息</div>
          <el-form-item label="签约状态" label-width="22%">
            <jm-dict-select
              clearable
              type="dataset"
              v-model="editData.custom_level"
              dict-type="student"
              name="customLevelType"
              @change="bindUserSignStatus"
            />
          </el-form-item>
          <el-form-item label="签约日期" label-width="22%">
            <el-date-picker
              v-model="editData.signing_date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              :editable="false"
              placeholder="选择日期"/>
          </el-form-item>
          <el-form-item label="办理国家" label-width="22%">
            <el-select
              v-model="editData.custom_active_country"
              multiple
              placeholder="请选择">
              <el-option
                v-for="item in this.countrys"
                :label="item.value"
                :value="item.id"
                :key="item.id"
                v-if="!canEditSayer || [1808, 1868, 2044, 1880].indexOf(item.id) === -1"/>
            </el-select>
          </el-form-item>
          <div class="form-hr" id="anchor6"><i></i><span>顾问信息</span></div>
          <el-form-item label="咨询老师" label-width="22%">
            <el-select v-model="editData.crm_sayer" placeholder="请选择" :disabled="!canEditSayer">
              <el-option-group v-for="(group, k) in teachers.advisory_teacher" :key="k" :label="k">
                <el-option
                  v-for="item in group"
                  :key="item.userid"
                  :label="item.truename"
                  :value="item.userid"
                />
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item label="申请老师" label-width="22%">
            <el-select v-model="editData.crm_writer" placeholder="请选择">
              <el-option-group v-for="(group, k) in teachers.write_teacher" :key="k" :label="k">
                <el-option
                  v-for="item in group"
                  :key="item.userid"
                  :label="item.truename"
                  :value="item.userid"
                />
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item label="规划老师" label-width="22%">
            <el-select v-model="editData.crm_planning" placeholder="请选择">
              <el-option-group v-for="(group, k) in teachers.planning_teacher" :key="k" :label="k">
                <el-option
                  v-for="item in group"
                  :key="item.userid"
                  :label="item.truename"
                  :value="item.userid"
                />
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item label="文书老师" label-width="22%">
            <el-select v-model="editData.crm_document" placeholder="请选择">
              <el-option-group v-for="(group, k) in teachers.document_teacher" :key="k" :label="k">
                <el-option
                  v-for="item in group"
                  :key="item.userid"
                  :label="item.truename"
                  :value="item.userid"
                />
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item label="代言计划" label-width="22%">
            <jm-dict-select
              clearable
              v-model="editData.rugby_people"
              type="dataset"
              dict-type="student"
              name="rugbyPeople"
              :disabled="!canEditSayer"
            />
          </el-form-item>
          <el-form-item label="合同号" label-width="22%">
            <el-input v-model="editData.contract_number" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="资料发送" label-width="22%" v-show="hasMaterial && materialData">
            <el-select
              clearable
              placeholder="请选择"
              v-model="editData.material_send"
            >
              <el-option
                v-for="item in materialData"
                :key="item.id"
                :label="`[${item.country}]${item.value}`"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="bottom-fixed-save" v-if="!infoReadOnly">
        <el-button type="primary" :loading="btnLock" @click="formSubmit">保存</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import header from './compoments/header';
import student from '@/pages/student/student';
import permissionMixin from '@/pages/student/permissionMixin';
import * as UserApi from '@/api/user.js';
import * as Country from '@/const/index.js';
import router from '@/router';
import _ from 'lodash';
import {
  jmAreaselect,
  jmEducationSelect,
  jmDictSelect,
  jmUploadFile,
  jmSchoolSearch
} from '@/components/tool';

export default {
  mixins: [student, permissionMixin],
  data() {
    return {
      btnLock: false,
      countrys: [],
      services: [],
      signType1: '',
      signType2: [],
      material_send: '',
      isEdit: true,
      editData: {
        custom_name: '',
        crm_tel: '',
        crm_qq: '',
        crm_weixin: '',
        crm_level_lv: '',
        custom_year: '',
        custom_month: '',
        crm_memo: '',
        custom_nickname_tell: '',
        create_person_value: '',
        create_time: '',
        custom_hope_country: [],
        activity_code: '',
        crm_zhuanxiang: '',
        country_business: '',
        jiemo_vip: '',
        short_study_abroad: '',
        custom_level: '',
        culture_sign_date: '',
        custom_active_country: [],
        crm_sayer: '',
        crm_writer: '',
        crm_planning: '',
        crm_document: '',
        rugby_people: '',
        contract_number: '',
        material_send: ''
      },
      singapore_explain: [{
        value: '新加坡',
        label: '新加坡'
      }, {
        value: '马来西亚',
        label: '马来西亚',
      }],
    };
  },
  computed: {
    // 展示逻辑
    canEditTraining() {
      if (this.userInfo.userid === this.is_crm_training) {
        return true;
      }
      if (this.infoReadOnly) {
        return false;
      }
      // admin 一直可以改 如果考培字段等于userid 可以改 若无 存在咨询老师可以改
      if (this.userInfo.userid === 1) {
        return true;
      }
      if (!this.is_crm_training && this.is_crm_sayer_same) {
        return true;
      }
      return false;
    },
    // 是否展示资料
    hasMaterial() {
      const enableCountry = [
        Country.COUNTRY_GB,
        Country.COUNTRY_JP,
        Country.COUNTRY_AU,
        Country.COUNTRY_QCRB
      ];
      return this.isInCountry(enableCountry);
    },
    /**
     * 是否有签约类型
     */
    hasSignType() {
      const enableCountry = [
        Country.COUNTRY_GB,
        // Country.COUNTRY_JP,
        Country.COUNTRY_AU,
        Country.COUNTRY_IE,
        Country.COUNTRY_NZ,
        Country.COUNTRY_SG,
        Country.COUNTRY_FR,
        Country.COUNTRY_HK
      ];
      return this.isInCountry(enableCountry);
    },
    /**
     * 是否是芥末日本学生
     */
    isJiemoJpStudent() {
      const enableCountry = [Country.COUNTRY_JP];
      return this.isInCountry(enableCountry);
    },
    /**
     * 是否有签约类型的starndard plus free 选项
     */
    hasStandard() {
      return this.isInCountry([
        Country.COUNTRY_GB,
        Country.COUNTRY_AU,
        Country.COUNTRY_IE,
        Country.COUNTRY_NZ,
        Country.COUNTRY_SG
      ]);
    },
    hasPlus() {
      return this.isInCountry([
        Country.COUNTRY_GB,
        Country.COUNTRY_AU,
        Country.COUNTRY_IE,
        Country.COUNTRY_NZ,
        Country.COUNTRY_SG,
        Country.COUNTRY_FR,
        Country.COUNTRY_HK
      ]);
    },
    canFree() {
      return this.isInCountry([
        Country.COUNTRY_GB,
        Country.COUNTRY_AU,
        Country.COUNTRY_IE,
        Country.COUNTRY_NZ
      ]);
    },
    /**
     * 资料发送数据
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @return {Array}
     */
    materialData() {
      let countries = [];
      this.editData.custom_hope_country.forEach((item) => {
        if (item === 83 || item === 485) {
          countries.push('ziliao_jp');
          return true;
        }
        if (item === 30) {
          countries.push('ziliao_uk');
          return true;
        }
        if (item === 31) {
          countries.push('ziliao_aus');
          return true;
        }
      });
      if (this.ds.material) {
        return this.ds.material.filter(item => countries.indexOf(item.type) > -1);
      }
    },
    /**
     * 老师数据，重新打包传递给子组件用
     */
    teachers() {
      return {
        advisory_teacher: this.filterTeachers(this.ds.advisory_teacher),
        write_teacher: this.filterTeachers(this.ds.write_teacher),
        planning_teacher: this.filterTeachers(this.ds.planning_teacher),
        document_teacher: this.filterTeachers(this.ds.document_teacher)
      };
    }
  },
  beforeRouteEnter(to, from, next) {
    UserApi.getBaseInfo(to.params.crmid)
      .then(({ data }) => {
        next((vm) => {
          vm.setStudentData(data);
        });
      })
      .catch(() => {
        router.replace({ name: 'h5UserList' });
      });

    return true;
  },
  methods: {
    bindUserSignStatus(val) {
      if (val === 7 && this.isLanguageSchool && !this.$hasPermission([1])) {
        if (!this.editData.custom_month) {
          this.$message.error('请填写入学时间');
          this.editData.custom_level = 0;
          return false;
        }
      }
      // if (val === 7 && this.mustHaveInterviewForm && !this.editData.signup_form) {
      //   this.$message.error('必须填写报名采集表，才能设置已签约状态');
      //   this.editData.custom_level = 0;
      //   return false;
      // }

      if (val === 7 && this.editData.crm_level_lv !== 57) {
        this.editData.crm_level_lv = 57;
        if (!this.editData.signing_date) {
          this.editData.signing_date = new Date();
        }
        return true;
      }

      if (val === 9 && this.editData.crm_level_lv !== 65) {
        this.editData.crm_level_lv = 65;
      }
    },
    /**
     * 必须有报名表
     */
    mustHaveInterviewForm() {
      if (this.editData.cms_sayer_country === 83 || this.editData.cms_sayer_country === 672) {
        return true;
      }
      return false;
    },
    /**
     * 是否为日本语言学校资源
     */
    isLanguageSchool() {
      return (
        this.$inCountry([83]) && this.editData.custom_hope_country.includes(83)
      );
    },
    /**
     * 过滤客服分级
     */
    crmLevelFilter(item) {
      if (this.infoReadOnly && !this.isOptManager && !this.isDataAnalyst && this.canEditByCreator && this.originLevel === 64 && [51, 53, 61, 60, 57, 55, 62, 63, 65, 66].indexOf(item.value) > -1) {
        return false;
      }

      if (item.value === 66) {
        return this.$hasPermission(1);
      }
      return true;
    },
    /**
     * 判断当前学生意向国家是否在国家列表内
     */
    isInCountry(countries) {
      return countries.some((item) => {
        return this.editData.custom_hope_country.indexOf(item) > -1;
      });
    },
    // 提交表单
    formSubmit: function() {
      if (this.formCheck()) {
        this.btnLock = true;
        this.editData.sign_type = `${this.signType1},${this.signType2}`;
        this.$http
          ._post({
            url: '/index/student/save',
            data: this.editData
          })
          .then(({ data, msg }) => {
            this.btnLock = false;
            router.replace({ name: 'h5User', params: { crm_id: data.crmid } });
            this.$message.success(msg || '保存成功');
          })
          .catch((data) => {
            this.btnLock = false;
            this.$message.error(data.msg);
          });
      }
    },
    // 表单验证
    formCheck: function() {
      let editData = this.editData;
      // if (!editData.custom_name) {
      //   this.$message.error('请填写姓名');
      //   return false;
      // }
      if (!editData.crm_tel && !editData.crm_weixin.trim() && !editData.crm_qq) {
        this.$message.error('请填写电话/微信/QQ三项中的一项');
        return false;
      }
      if (!editData.crm_level_lv) {
        this.$message.error('请选择客户分级');
        return false;
      }
      if (!editData.custom_hope_country) {
        this.$message.error('请选择意向国家');
        return false;
      }
      if (this.isUA() && (this.editData.custom_level === 7) && !this.signType1) {
        this.$message.error('请选择签约类型');
        return false;
      }
      if (this.editData.custom_level === 7 && !this.editData.signing_date) {
        this.$message.error('请选择签约日期');
        return false;
      }
      if (this.editData.custom_level === 7 && (!this.editData.custom_year || !this.editData.custom_month)) {
        this.$message.error('请填写入学时间');
        return false;
      }
      if (this.editData.custom_level === 7 && !this.editData.crm_planning && (this.editData.custom_hope_country.indexOf(83) > -1 || this.editData.custom_hope_country.indexOf(485) > -1)) {
        this.$message.error('请选择规划老师');
        return false;
      }
      if (this.editData.custom_hope_country.indexOf(2061) > -1 && !this.editData.singapore_explain) {
        this.$message.error('意向国家包含新加坡时，说明必填');
        return false;
      }
      return true;
    },
    isUA() {
      let hpCountry = this.editData.custom_hope_country;
      let isUA = false;
      let signCountry = [30, 31, 674, 673, 675, 1831, 1770];
      for (let i = 0; i < hpCountry.length; i++) {
        if (this.isInArray(signCountry, hpCountry[i])) {
          isUA = true;
          break;
        }
      }
      return isUA;
    },
    isInArray(arr, value) {
      for (let i = 0; i < arr.length; i++) {
        if (value === arr[i]) {
          return true;
        }
      }
      return false;
    },
    // 获取用户数据
    setStudentData(data) {
      this.editData = Object.assign(this.editData, data);
      if (
        this.editData.crm_sayer &&
        this.editData.crm_training &&
        this.editData.crm_sayer !== this.editData.crm_training
      ) {
        this.is_crm_sayer = true;
      }
      this.formatStudentData();
    },
    formatStudentData() {
      if (this.editData.custom_year !== null) {
        this.editData.custom_year = String(this.editData.custom_year);
      }
      if (this.editData.custom_month !== null) {
        this.editData.custom_month = String(this.editData.custom_month);
      }
      if (this.editData.custom_graduation !== null) {
        this.editData.custom_graduation = String(this.editData.custom_graduation);
      }
    },

    /**
     * 初始化签约类型
     */
    initSignType() {
      let signType = this.editData.sign_type || '';
      signType.split(',').forEach((item) => {
        item = +item;
        if (item > 0) {
          if (item < 4) {
            this.signType1 = item;
          } else {
            this.signType2.push(item);
          }
        }
      });
    },
    // 客户分级逻辑
    bindUserStatus(val) {
      if (val === 57) {
        if (this.editData.crm_tel !== '') {
          this.editData.custom_level = 7;
        } else {
          this.$message.error('签约用户必须填写手机号');
          return false;
        }
        return true;
      }
      if (val === 65) {
        this.editData.custom_level = 9;
        return true;
      }
      this.editData.custom_level = '';
    },
    /**
     * 老师筛选
     * @author liushaochen
     * @param  {[type]} teachers   老师列表
     * @param  {Array}  teacherIds 默认加入列表的老师数组
     * @return {[type]}            [description]
     */
    filterTeachers(teachers, teacherIds = []) {
      if (!teachers) {
        return teachers;
      }
      let currentTeachers = { ...teachers };
      Object.entries(currentTeachers).forEach(([char, teacher]) => {
        teacher = teacher.filter((t) => {
          // 超管
          if (t.userid === -1) {
            return true;
          }

          // 前筛咨询展示
          if (t.roleid === 161) {
            return true;
          }

          // 无效的老师
          if (teacherIds.length > 0 && teacherIds.indexOf(t.userid) === -1) {
            return false;
          }

          return (
            this.editData.custom_hope_country.indexOf(t.country) > -1 ||
            // 待激活咨询
            t.country === 1808 ||
            // 考培
            // t.country === 1868 ||
            // 英美和日韩中心共用老师
            ([-1, -2].indexOf(t.country) !== -1 &&
              _.intersection(this.editData.custom_hope_country, this.countryCode.concat(this.countryCode1)).length) ||
            // 星耀东大老师
            (t.country === -3 &&
              _.intersection(this.editData.custom_hope_country, this.countryCode2).length)
          );
        });
        currentTeachers[char] = teacher;
        if (teacher.length === 0) {
          delete currentTeachers[char];
        }
      });
      return currentTeachers;
    },
  },
  watch: {},
  mounted() {
    this.getDatasource().then(() => {
      this.services = this.ds.projects;
    });
    this.$nextTick(() => {
      this.countrys = JSON.parse(localStorage.getItem('fib_dict_ds')).data.online.country;
      this.initSignType();
      let anchor = this.$route.params.anchor;
      if (anchor && typeof anchor !== 'object') {
        anchor = +anchor;
        if (anchor !== 1) {
          document.getElementById(`anchor${anchor}`).scrollIntoView();
        } else {
          document.getElementById('anchor1').scrollIntoView();
        }
      }
    });
  },
  components: {
    'wap-header': header,
    jmAreaselect,
    jmEducationSelect,
    jmDictSelect,
    jmUploadFile,
    jmSchoolSearch,
  }
};
</script>
<style>
  .user-edit-wrap .form-area .jm-channel-select .el-select{
    width: 100% !important;
    margin-bottom: 2vw;
  }
  .user-edit-wrap .form-area .el-form-item .el-form-item__label{
    color: #888;
    font-size: 3.73vw;
  }
  .user-edit-wrap .form-area .el-form-item.moreline .el-form-item__label{
    line-height: 5vw;
  }
</style>
<style scoped>
  .user-edit-wrap .form-area{
    margin-top: -5vw;
  }
  .user-edit-wrap .title-area{
    padding-left: 4vw;
    font-size: 4vw;
    color: #666;
    line-height: 12.2vw;
    background: #f8f8f8;
    margin: 5vw -5vw;
    clear: both;
  }
  .user-edit-wrap .form-area{
    background: #fff;
    padding: 0 5vw 4vw;
  }
  .user-edit-wrap .form-area .el-form{
    margin-top: 0;
  }
  .user-edit-wrap .form-area .el-form-item{
    margin-bottom: 0;
  }
  .user-edit-wrap .form-area .el-form-item + .el-form-item{
    margin-top: 3vw;
  }
  .user-edit-wrap .form-area .el-select, .user-edit-wrap .form-area .el-date-editor, .user-edit-wrap .form-area el-date-picker{
    width: 100%;
  }
  .user-edit-wrap .form-area .morewrap{
    display: flex;
    justify-content: space-between;
  }
  .user-edit-wrap .form-area .morewrap .el-select, .user-edit-wrap .form-area .morewrap .moremode{
    width: 48.4%;
  }
  .user-edit-wrap .jm-dict-select{
    width: 100%;
  }
  .user-edit-wrap .form-area .form-hr{
    clear: both;
    padding: 7vw 0;
    position: relative;
  }
  .user-edit-wrap .form-area .form-hr i{
    display: block;
    width: 100%;
    height: 0;
    border-top: 1px dashed #ececec;
  }
  .user-edit-wrap .form-area .form-hr span{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background: #fff;
    font-size: 3.73vw;
    padding: 0 7vw;
    color: #939393;
  }
  .user-edit-wrap .form-area .el-form-item .text-area{
    line-height: 6vw;
    font-size: 3.73vw;
    display: inline-block;
    vertical-align: text-top;
  }
  .user-edit-wrap .bottom-fixed-save{
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 21;
    width: 100%;
    height: 19vw;
    line-height: 16vw;
    background: #fff;
    border-top: 0.5px solid #CFCFCF;
    text-align: center;
  }
  .user-edit-wrap .bottom-fixed-save .el-button{
    width: 65.8vw;
    height: 10.6vw;
    border-radius: 5.3vw;
    border: none;
  }
</style>
